<template>
  <!-- <div class="k3" v-if="!isPortrait">
   <div class="fullPage" ref="fullPage">
      <div class="fullPageContainer"
           ref="fullPageContainer"
      >
        <div class="section section1">
          <Header v-show="!minip" @forbid="forbid" @open="open"/>
          <Onepage @showCover="showCover" @customPage="gotoBlock(3)"/>
        </div>
        <div class="section section2">
          <Twopage @showCover="showCover" />
        </div>
         <div class="section section3" ref="pc-block3" v-if="!isPortrait">
          <Fivepage />
        </div>
        <div class="section section5" :class="{'section5-portrait': isPortrait}" ref="footer">
          <Footer v-show="!minip"/>
        </div>
      </div>
      <div class="cover" :class="{'cover-show': isShowCover}">
        <MyForm @hideCover="showCover(false)"></MyForm>
      </div>
      <div class="cover2" v-if="isShowCover"></div>
    </div>
  </div> -->
  <!-- 广告页 -->
<!-- <K3MOB></K3MOB>-->
  <!-- 售后政策页 -->
  <SALESPOLICYPC v-if="!isPortrait"></SALESPOLICYPC>
  <SALESPOLICY v-else></SALESPOLICY>


</template>

<script>
import K3MOB from "./Mob/index.vue"
import SALESPOLICY from "./salesPolicy/index.vue"
import SALESPOLICYPC from "./salesPolicy/salesPolicyPC.vue"
// import Header from "@/components/Header";
 import Onepage from "@/components/Onepage";
// import Twopage from '@/components/Twopage';
// import Fivepage from '@/components/Fivepage'
// import Footer from "@/components/Footer";
// import MyForm from "@/components/My-Form";
import { isPortraitFun,getUrlKey,throttle,debounce } from "@/utils/utils.js";
export default {
  name:'index',
  components: { Onepage, SALESPOLICY, SALESPOLICYPC,K3MOB },
  data() {
    return {
      isPortrait: isPortraitFun(),
      minip:false,
      flag:false,
      isShowCover: false, // 显示留资弹窗
    };
  },
  mounted: function () {
    const _that = this
    if(getUrlKey("minip")){
      this.minip = true
    }
  },
  methods: {
    forbid(){
      this.flag = true;
    },
    open(){
      this.flag = false;
    },
    gotoBlock(e) { // 用锚点跳转到固定的div块
      console.log(e);
      const el = this.$refs[`pc-block${e}`];
      el.scrollIntoView()
    },
  },
  created: function () {
  }
}

</script>

<style lang="scss" scoped>
.fullPage {
  padding: 0;
  margin: 0;
  height: calc(100vh);
  overflow: hidden;
  background-color: #fff;
  color: #000000;
}
.fullPageContainer {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  transition: all ease-out 0.8s;
}
.section {
  width: 100%;
  height: calc(100vh);
  background-position: center center;
  background-repeat: no-repeat;
  transform: translate3d(0,0,0);
}
.section5{
  height: auto;
  background: #1f1f1f;
  &-portrait {
    height: 100vh;
  }
}

.cover {
  width: 100%;
  height: 90vh;
  position: fixed;
  z-index: 9;
  top: 100vh;
  left: 0;
  transition: all 0.6s ease;
  overflow: auto;
  background: rgba($color: #000000, $alpha: 0.8);
  &-show {
    top: 10vh;
  }
}
.cover2 {
  width: 100%;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.7);
  position: fixed;
  z-index: 8;
  top: 0;
  left: 0;
}
.section2{
  height:unset;
}
</style>
